var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "information-list" } },
    [
      _c("span", { staticClass: "headtitle" }, [
        _vm._v(" " + _vm._s(_vm.$t("message.defaultContents")) + " "),
      ]),
      _vm._v(" "),
      _c("b-form-input", {
        staticClass: "mb-3",
        attrs: { placeholder: "Ara..." },
        model: {
          value: _vm.query,
          callback: function ($$v) {
            _vm.query = $$v
          },
          expression: "query",
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.getActives(), function (content, index) {
        return _c(
          "div",
          {
            staticClass: "contentInfo",
            attrs: { id: "contents_" + _vm.renderCount },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle",
                    value: "shortcut-accordion-" + index,
                    expression: "`shortcut-accordion-${index}`",
                  },
                ],
                staticClass: "contentInfo first",
                attrs: { id: "fakeDefaultContents", "data-v-step": "20" },
                on: {
                  click: function ($event) {
                    _vm.visibleContentId =
                      _vm.visibleContentId !== content._id
                        ? content._id
                        : undefined
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getLanguageContent(
                        content,
                        _vm.myDefaultContentLang,
                        "name",
                        ""
                      )
                    ) +
                    "\n            "
                ),
                _vm.visibleContentId === content._id
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          float: "right",
                          transform: "rotate(180deg)",
                        },
                      },
                      [_c("downButton")],
                      1
                    )
                  : _c(
                      "span",
                      { staticStyle: { float: "right" } },
                      [_c("downButton")],
                      1
                    ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-collapse",
              {
                attrs: {
                  id: "shortcut-accordion-" + index,
                  accordion: "shortcuts-accordion",
                  role: "tabpanel",
                },
              },
              _vm._l(_vm.getChildren(content), function (subContent) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    key: subContent._id,
                    staticClass: "contentButton",
                    class: subContent.type.toLowerCase(),
                    attrs: {
                      content:
                        _vm.getLanguageContent(
                          subContent,
                          _vm.myDefaultContentLang,
                          "content",
                          null
                        ) ||
                        _vm.getLanguageContent(
                          subContent,
                          _vm.myDefaultContentLang,
                          "description",
                          ""
                        ),
                      "data-id": subContent._id,
                      "data-letter": (subContent.letter || "").toLowerCase(),
                      "data-number": (subContent.number || "").toLowerCase(),
                    },
                    on: {
                      click: function ($event) {
                        _vm.onShortcutSelected(
                          _vm.getLanguageContent(
                            subContent,
                            _vm.myDefaultContentLang,
                            "content",
                            null
                          ) ||
                            _vm.getLanguageContent(
                              subContent,
                              _vm.myDefaultContentLang,
                              "description",
                              ""
                            )
                        )
                      },
                    },
                  },
                  [
                    subContent.type.toLowerCase() === "alt"
                      ? _c(
                          "div",
                          {
                            staticClass: "contentInfo sec",
                            staticStyle: { cursor: "pointer" },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.isMac ? "CTRL" : "ALT") +
                                " +\n                    " +
                                _vm._s(subContent.letter) +
                                "\n                "
                            ),
                          ]
                        )
                      : subContent.type.toLowerCase() === "tab"
                      ? _c(
                          "div",
                          { staticClass: "contentInfo sec" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(subContent.letter) +
                                "\n                    "
                            ),
                            _c("right-button"),
                            _vm._v(
                              "\n                    tab\n                    "
                            ),
                            _c("right-button"),
                            _vm._v(
                              "\n                    " +
                                _vm._s(subContent.number) +
                                "\n                "
                            ),
                          ],
                          1
                        )
                      : subContent.type.toLowerCase() === "hash"
                      ? _c(
                          "div",
                          {
                            staticClass: "contentInfo sec",
                            staticStyle: { cursor: "pointer" },
                          },
                          [
                            _vm._v(
                              "\n                    #" +
                                _vm._s(subContent.hash) +
                                "\n                "
                            ),
                          ]
                        )
                      : _c("div", [
                          _vm._v(_vm._s(_vm.$t("message.noShortCut"))),
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "contentInfo three" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getLanguageContent(
                              subContent,
                              _vm.myDefaultContentLang,
                              "name",
                              ""
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }